import { BUTTON_SIZES } from '@elliemae/ds-button-v2';
import { DatePicker } from '@elliemae/ds-icons';
import { useContext, useMemo } from 'react';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { CalendarWithTimeWheelContext } from './CalendarWithTimeWheelContext.js';
import { StyledIconTriggerButton } from './Styleds.js';

// we memoize the Icon  for maximum optimization
// this is particularly useful due to how usePopper needs to check the references
// since references are saved in a immutable way, we make sure to shortcircuit useless-re-renders
export const CalendarWithTimeWheelIconTrigger = (): JSX.Element => {
  const {
    handleSetTriggerRef,
    handleToggleCalendarWithTimeWheel,
    handlePickerIconKeyDown,
    ariaCurrentValueForInputs,
    disabled,
  } = useContext(CalendarWithTimeWheelContext);
  const {
    getProps,
    props: { tabIndex },
  } = useContext(ControlledDateTimePickerContext);
  return useMemo(
    () => (
      <StyledIconTriggerButton
        aria-label={`date time picker context menu trigger, ${ariaCurrentValueForInputs}`}
        buttonType="icon"
        type="button"
        size={BUTTON_SIZES.M}
        innerRef={handleSetTriggerRef}
        tabIndex={tabIndex}
        onClick={handleToggleCalendarWithTimeWheel}
        onKeyDown={handlePickerIconKeyDown}
        data-testid={ControlledDateTimePickerDatatestid.PICKER_ICONS.CALENDAR_TIMEWHEEL}
        disabled={disabled}
        getOwnerProps={getProps}
      >
        <DatePicker color={disabled ? ['neutral', '500'] : ['brand-primary', '800']} />
      </StyledIconTriggerButton>
    ),
    [
      ariaCurrentValueForInputs,
      disabled,
      getProps,
      handlePickerIconKeyDown,
      handleSetTriggerRef,
      handleToggleCalendarWithTimeWheel,
      tabIndex,
    ],
  );
};
